module.exports = "/_next/static/images/michigan-846a67b406f2f8073cc5e243135324bd.svg";